<template>
  <div id="main_header">
    <div id="mobile_menu" class="position-relative">
      <button @click="open_mobile_menu()">
        <i class="kgk-mtn-menu"></i>
      </button>
      <button
        class="ml-1 search"
        v-if="$route.name !== 'search'"
        @click="
          $router.push({
            name: 'search',
          })
        "
      >
        <i class="kgk-mtn-search"></i>
      </button>
    </div>
    <div id="main_header_welcome">
      <div class="text-truncate">
        Y'ello
        <span class="ml-1" v-if="!isEmpty($store.state.core.subscriber)">
          {{ $store.state.core.subscriber.infos.first_name }}
        </span>
      </div>
      <p>{{ utils_get_config_message("welcome_message") }}</p>
    </div>

    <div class="w-100 d-flex justify-content-between flex-wrap">
      <div id="main_header_left">
        <MainBalance
          :icon="'kgk-mtn-BW_Icons_MTNBusiness_Mobility_4'"
          :iconBg="'#FDE0C7'"
          :tcolor="'#D36709'"
          :balance="$store.state.core.balance"
          :balance_sub="'Solde principal'"
        />
      </div>

      <div id="main_header_right">
        <div class="d-flex align-items-center">
          <a href="#" class="mr-3 d-lg-none d-md-flex">
            <i class="mtn-icon mtn-icon-search"></i>
          </a>
          <div class="d-sm-none d-lg-flex position-relative mr-3">
            <input
              type="text"
              placeholder="Recherche"
              v-model="search_model"
              @keyup.enter="searchSomething()"
            />
            <i class="kgk-mtn-search icon-search"></i>
          </div>
          <UserAvatar />
        </div>
      </div>
    </div>
    <div
      @click="close_mobile_menu()"
      class="modal-backdrop d-none"
      id="main_header_left_backdrop"
    ></div>
    <div class="mtn-separator">
      <div class="mtn-curve">
        <div>
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            height="25px"
            viewBox="0 0 500 25"
            style="enable-background: new 0 0 500 25"
            xml:space="preserve"
            preserveAspectRatio="none"
            class="mtn-curve__convex mtn-curve__curve-mobile"
          >
            <path
              d="M0,0c166.7,33.3,333.3,33.3,500,0H0z"
              class="mtn-svg-fill--yellow"
            ></path>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { subscriber } from "@/services/";
import MainBalance from "./MainBalance";
import UserAvatar from "./UserAvatar";
export default {
  components: { MainBalance, UserAvatar },
  name: "MainHeader",
  data: function () {
    return {
      main_balance: null,
      search_model: "",
    };
  },
  created: async function () {
    this.get_main_balance();
    this.$store.state.core.current_search = this.$route.query.value;
    this.search_model = this.$store.state.core.current_search;
  },
  methods: {
    get_main_balance: async function () {
      await subscriber.get_main_balance();
    },
    open_mobile_menu: function () {
      $("#main_left_menu").addClass("open");
      $("#main_header_left_backdrop").removeClass("d-none").fadeIn();
    },
    close_mobile_menu: function () {
      $("#main_left_menu").removeClass("open");
      $("#main_header_left_backdrop").fadeOut().addClass("d-none");
    },
    searchSomething() {
      if (
        this.search_model.trim() !== "" &&
        this.search_model.trim() !== this.$route.query.value
      ) {
        this.$store.state.core.current_search = this.search_model;
        this.$router.push({
          name: "search",
          query: {
            value: this.$store.state.core.current_search,
          },
        });
      }
    },
  },
};
</script>
<style scoped lang="css">
#main_header_right input {
  border-radius: 20px !important;
  border: 1px solid #6c757d !important;
  max-width: 300px !important;
  height: 36px;
  padding: 4px 12px !important;
  padding-right: 28px !important;
}
::placeholder {
}
.search {
  position: absolute;
  right: 15px !important;
}
.icon-search {
  position: absolute;
  right: 10px;
  top: 9px;
}
</style>
